import * as yup from 'yup';

export const SIGN_IN_SCHEMA = yup.object({
  email: yup.string().email().required('Email is required'),
  password: yup.string().required('Password is required'),
});

export type SignInFormState = yup.InferType<typeof SIGN_IN_SCHEMA>;
